import React from 'react';
import { Input } from 'antd';

const IntegerInput = ({ maxLength = 30, placeholder, onChange, ...rest }) => {
    const handleKeyDown = (e) => {
        // Block non-numeric keys
        if (['e', 'E', '.', '+', '-'].includes(e.key)) {
            e.preventDefault();
        }
    };

    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); // remove all non-digits
        if (onChange) {
            // Trigger the onChange with cleaned value
            onChange({ target: { value } });
        }
    };

    return (
        <Input
            type="text"
            inputMode="numeric" // Show number keyboard on mobile
            pattern="\d*"
            maxLength={maxLength}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            placeholder={placeholder}
            {...rest}
        />
    );
};

export default IntegerInput;
